var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.5C23.2842 0.5 30 7.21572 30 15.5C30 23.7842 23.2842 30.5 15 30.5C6.71572 30.5 0 23.7842 0 15.5C0 7.21572 6.71572 0.5 15 0.5ZM15 2.75C7.95837 2.75 2.25 8.45837 2.25 15.5C2.25 22.5416 7.95837 28.25 15 28.25C22.0416 28.25 27.75 22.5416 27.75 15.5C27.75 8.45837 22.0416 2.75 15 2.75ZM13.125 17.6589L19.8295 10.9545C20.2689 10.5152 20.9811 10.5152 21.4205 10.9545C21.8199 11.3539 21.8562 11.9789 21.5294 12.4193L21.4205 12.5455L13.9205 20.0455C13.5212 20.4449 12.8961 20.4812 12.4557 20.1544L12.3295 20.0455L8.5795 16.2955C8.14017 15.8561 8.14017 15.1439 8.5795 14.7045C8.97891 14.3051 9.6039 14.2688 10.0443 14.5957L10.1705 14.7045L13.125 17.6589Z",
    fill: "#16C265"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.4c819a56abf52f87d8562099b9367c0a.svg";
export { ForwardRef as ReactComponent };